import { useState,useContext } from "react";
import { GlobalProvider } from "../Context/GlobalState";
import { GlobalContext } from "../Context/GlobalState";
import { useNavigate } from "react-router-dom";
import axios from "axios";


export default function MunavebeKayit() {
  const navigate = useNavigate();
  const { API_URL,isLogin,bilirkisi,setBilirkisi } = useContext(GlobalContext);

console.log("bilirkisiler :>> ", bilirkisi);
  const kullaniciAdi = window.localStorage.getItem("user");
  var [eklenecekBilirkisi, setEklenecekBilirkisi] = useState({
    name: "",
    bilirkisiUnvani: "",
    bilirkisiSicilNo: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEklenecekBilirkisi((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  //bilirkişi kaydet
  const bilirkisiDbyeKaydet = (e) => {
    e.preventDefault();
    var data = JSON.stringify(eklenecekBilirkisi);
    axios
      .post(API_URL + "/bilirkisikaydet", {
        kullaniciAdi,
        data,
      })
      .then((response) => {
        alert(response.data);
      })
      .catch((error) => {
        alert("Bir hata Oluştu!");
        console.error("There was an error!", error);
      });
  };


      const bilirkisiSil = async (id) => {
        if (!window.confirm("Bu Bilirkişi silinsin mi?")) return;

        try {
          await axios.delete(`${API_URL}/bilirkisi/${id}`);

          setBilirkisi((prev) => prev.filter((item) => item.id !== id));

          alert("Bilirkişi silindi.");
        } catch (err) {
          console.log(err.data);
          alert("Silinemedi.");
        }
      };

  return (
    <GlobalProvider>
      {isLogin ? (
        <div className="container">
          <div className="row">
            <h1 className="text-center">Bilirkişi Kayıt </h1>
          </div>

          <form onSubmit={bilirkisiDbyeKaydet}>
            <div className="row">
              <div className="row mt-5 justify-content-center">
                <div className="col-6 mt-1 mb-2 mx-2">
                  <div className="row">
                    <input
                      type="text"
                      name="name"
                      id="name"
                      placeholder="Bilirkişi Ad Soyad Giriniz"
                      className="form-control my-2"
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="row">
                    <input
                      type="text"
                      name="bilirkisiUnvani"
                      id="bilirkisiUnvani"
                      placeholder="Bilirkişi Ünvanı"
                      className="form-control mt-1"
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="row">
                    <input
                      type="text"
                      name="bilirkisiSicilNo"
                      id="bilirkisiSicilNo"
                      placeholder="Bilirkişi Sicil No"
                      className="form-control my-2"
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col"></div>
              <div className="col"></div>
              <div className="col"></div>
              <div className="col">
                <button type="submit" className="btn btn-primary btn-lg mt-5">
                  Bilirkişi Kaydet
                </button>
              </div>
            </div>
          </form>
          <hr className="my-5" />

          <h3>Kayıtlı Bilirkişiler</h3>

          <table className="table table-striped table-hover">
            <thead className="table-dark">
              <tr>
                <th>#</th>
                <th>Bilirkişi Adı</th>
                <th>İşlem</th>
              </tr>
            </thead>

            <tbody>
              {bilirkisi.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.name}</td>

                  <td width="120">
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => bilirkisiSil(item.id)}
                    >
                      Sil
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        navigate("/")
      )}
    </GlobalProvider>
  );
}
